import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

const defaultSorted = [{ dataField: 'code', order: 'desc' }];

const List = (props) => {
  const { entities, totalCount, intl, setQueryParams, listLoading } = props;
  const productAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PRODUCTAMOUNT',
  });
  const stockAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.STOCKAMOUNT',
  });
  const purchaseItemAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PURCHASEITEMAMOUNT',
  });

  // Table columns
  const columns = [
    {
      dataField: 'productAmount',
      text: productAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'stockAmount',
      text: stockAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'purchaseItemAmount',
      text: purchaseItemAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-info',
    },
  ];

  return (
    <BootstrapTable
      key='financeStockTotal'
      wrapperClasses='table-responsive'
      bordered={false}
      classes='table table-head-custom table-vertical-center overflow-hidden'
      bootstrap4
      local
      keyField='orderAmount'
      data={entities === null ? [] : entities}
      columns={columns}
      defaultSorted={defaultSorted}
      onTableChange={getHandlerTableChange(setQueryParams)}
    >
      <PleaseWaitMessage entities={entities} />
      <NoRecordsFoundMessage entities={entities} />
    </BootstrapTable>
  );
};

export default injectIntl(List);
